module.exports = __webpack_public_path__ + "static/img/SACHMAN.9aaa3a72.png";